<ion-header
  role="navigation"
  [attr.aria-label]="'desktop.navigation' | translate"
  class="top-nav ion-no-border"
>
  <ion-toolbar>
    <ion-buttons slot="start">
      <a
        class="brand"
        routerLink="/"
      >
        @if (appLogo) {
          <img
            [src]="appLogo"
            class="brand--logo"
            [attr.alt]="appName"
            crossorigin="anonymous"
          />
        } @else {
          <img
            [src]="appIcon"
            class="brand--icon"
            alt=""
          />
          <span class="brand--name">{{ appName }}</span>
        }
      </a>
    </ion-buttons>

    <div class="center">
      <app-link
        label="tab.feed"
        link="/feed"
      ></app-link>
      <app-link
        label="tab.participation"
        link="/participation"
        [badgeCount]="participationOpenCount"
        badgeLabel="participation.open"
      ></app-link>
      @if (!isProjectApp) {
        <app-link
          label="tab.following"
          link="/following"
        ></app-link>
      } @else {
        <app-link
          label="tab.project"
          link="/project"
        ></app-link>
      }
    </div>

    <ion-buttons slot="end">
      @if (!isProjectApp) {
        <app-link
          label="tab.search"
          link="/search"
          icon="/assets/icons/navigation/search.svg"
        ></app-link>
      }

      <app-link
        label="page.notifications"
        link="/notifications"
        icon="/assets/icons/notifications.svg"
        [badgeCount]="unreadNotificationCount"
        badgeLabel="notifications.unread"
      ></app-link>

      <app-link
        label="tab.settings"
        link="/settings"
        icon="/assets/icons/navigation/settings.svg"
      ></app-link>

      <div class="auth">
        @if (loadingUser()) {
          <ion-skeleton-text
            [animated]="true"
            style="width: 32px; height: 32px; border-radius: 50%; margin: 0 2px"
          ></ion-skeleton-text>
        } @else if (!user()) {
          <ion-button
            color="primary"
            fill="solid"
            href="#"
            (click)="goToLogin($event)"
            class="auth--button"
          >
            {{ 'page.login' | translate }}
          </ion-button>
        } @else {
          <app-user-avatar />
        }
      </div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
